import { FuelType } from '../models/fuel-type.enum';
import { CarType } from '../models/car-type.enum';

export interface ICarModel {
  id: string;
  priceInSek: number;
  fuelType: FuelType;
  emissionsCo2PerKm: number;
  type: CarType;
  fuelConsumptionPer10Km: number;
  fuelConsumptionType: FuelConsumptionType;
  privateLeasingCost?: number;
  weightKg?: number;
  detailsReference?: string;
}

enum FuelConsumptionType {
  L100km = 'l/100km',
  KWh100km = 'kWh/100km',
}

export const CarModelConstants: ICarModel[] = [
  {
    id: 'Toyota aygo',
    priceInSek: 187900,
    fuelType: FuelType.Petrol,
    emissionsCo2PerKm: 111,
    type: CarType.Basic,
    fuelConsumptionPer10Km: 0.49,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 2900,
    weightKg: 930,
    detailsReference: 'https://easyprivatleasing.toyota.se/',
  },
  {
    id: 'Dacia Duster',
    priceInSek: 264900,
    fuelType: FuelType.Diesel,
    emissionsCo2PerKm: 141,
    type: CarType.Basic,
    fuelConsumptionPer10Km: 0.54,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 3600,
    weightKg: 1400,
    detailsReference: 'https://www.wayke.se/',
  },
  {
    id: 'MG 4 Standard',
    priceInSek: 394900,
    fuelType: FuelType.Electric,
    emissionsCo2PerKm: 0,
    type: CarType.Basic,
    fuelConsumptionPer10Km: 1.7,
    fuelConsumptionType: FuelConsumptionType.KWh100km,
    privateLeasingCost: 3500,
    detailsReference: 'https://www.mgmotor.eu/sv-SE/',
  },
  {
    id: 'Volkswagen ID3',
    priceInSek: 444900,
    fuelType: FuelType.Electric,
    emissionsCo2PerKm: 0,
    type: CarType.Normal,
    fuelConsumptionPer10Km: 1.55,
    fuelConsumptionType: FuelConsumptionType.KWh100km,
  },
  {
    id: 'Volkswagen Tiguan',
    priceInSek: 349900,
    fuelType: FuelType.Petrol,
    emissionsCo2PerKm: 141,
    type: CarType.Normal,
    fuelConsumptionPer10Km: 0.62,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 4695,
    weightKg: 1900,
    detailsReference: 'https://dinbil.se/volkswagen',
  },
  {
    id: 'Volkswagen T-ROC R-LINE',
    priceInSek: 391900,
    fuelType: FuelType.Diesel,
    emissionsCo2PerKm: 141,
    type: CarType.Normal,
    fuelConsumptionPer10Km: 0.56,
    fuelConsumptionType: FuelConsumptionType.L100km,
    weightKg: 1450,
    detailsReference:
      'https://www.volkswagen.se/sv/bygg-din-bil.html/__app/30361/standard/t-roc-r-line.app?---=%7B%22configuration-step-navigation-service%22%3A%22%2F%3FconfigStep%3D%257B%2522context%2522%253A%252230361-31090-T-Roc%2BR-Line%2522%252C%2522selectedStep%2522%253A%2522engine%2522%257D%22%7D&carlineId-app=30361&modelId-app=D1156T%24GRBPRBP%24GWFFWFF%24GWW1WW1%24GYGMYGM%24GYOSYOS&modelVersion-app=1&modelYear-app=2024&salesGroupId-app=31090&category-app=private&trimName-app=T-Roc+R-Line&exteriorId-app=F14+2T2T&interiorId-app=F56+++++OC&buildabilityStatus-app=buildable',
  },
  {
    id: 'Tesla model Y',
    priceInSek: 574100,
    fuelType: FuelType.Electric,
    emissionsCo2PerKm: 0,
    type: CarType.Large,
    fuelConsumptionPer10Km: 1.57,
    fuelConsumptionType: FuelConsumptionType.KWh100km,
    privateLeasingCost: 9500,
    detailsReference: 'https://www.leaseplan.com/sv-se/privatleasing/',
  },
  {
    id: 'Volkswagen Passat Business',
    priceInSek: 463900,
    fuelType: FuelType.Diesel,
    emissionsCo2PerKm: 150,
    type: CarType.Large,
    fuelConsumptionPer10Km: 0.57,
    weightKg: 1600,
    fuelConsumptionType: FuelConsumptionType.L100km,
  },
  {
    id: 'Skoda Superb Combi',
    priceInSek: 455700,
    fuelType: FuelType.Petrol,
    emissionsCo2PerKm: 127,
    type: CarType.Large,
    fuelConsumptionPer10Km: 0.56,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 6975,
    weightKg: 1600,
    detailsReference: 'https://privatleasing.skoda.se/',
  },
  {
    id: 'Volvo EC40 Black Edition Ultra',
    priceInSek: 705000,
    fuelType: FuelType.Electric,
    emissionsCo2PerKm: 0,
    type: CarType.Premium,
    fuelConsumptionPer10Km: 1.66,
    fuelConsumptionType: FuelConsumptionType.KWh100km,
    privateLeasingCost: 12690,
    detailsReference: 'https://volvocars.com',
  },
  {
    id: 'Audi A6 Avant 40 TDI quattro',
    priceInSek: 569100,
    fuelType: FuelType.Diesel,
    emissionsCo2PerKm: 146,
    type: CarType.Premium,
    fuelConsumptionPer10Km: 0.56,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 7500,
    weightKg: 1850,
    detailsReference: 'https://dinbil.se/',
  },
  {
    id: 'Mercedes-Benz C 300 4MATIC Line Kombi',
    priceInSek: 566900,
    fuelType: FuelType.Petrol,
    emissionsCo2PerKm: 146,
    type: CarType.Premium,
    fuelConsumptionPer10Km: 0.7,
    fuelConsumptionType: FuelConsumptionType.L100km,
    privateLeasingCost: 9023,
    weightKg: 1750,
    detailsReference: 'https://www.mercedes-benz.se/',
  },
];
